import { Fragment } from 'react';
import { useLocation } from '@tanstack/react-router';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@ui/breadcrumb.tsx';
import { LinkProtected } from '@r/components/link-protected/link-protected.tsx';
import { useRoutes } from '@r/hooks/use-routes.ts';
import { useTranslation } from 'react-i18next';
import type { LinkProps } from '@tanstack/react-router';

const AppBreadcrumb = () => {
  const { t } = useTranslation();
  const routes = useRoutes();
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  function isRouteExist(path: LinkProps['to']) {
    return routes.data?.find((route) => route.path == path);
  }

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          {location.pathname !== '/' ? (
            <BreadcrumbLink asChild>
              <LinkProtected to="/">{t('breadcrumb.dashboard')}</LinkProtected>
            </BreadcrumbLink>
          ) : (
            <BreadcrumbPage>{t('breadcrumb.dashboard')}</BreadcrumbPage>
          )}
        </BreadcrumbItem>
        {segments.map((segment, index) => {
          const path: LinkProps['to'] = `/${segments
            .slice(0, index + 1)
            .join('/')}` as LinkProps['to'];
          const isLast = index === segments.length - 1;
          const translationKey = `breadcrumb.${
            Number.isNaN(Number(segment)) ? segment.replace(/[-_]/g, '.') : 'detail'
          }`;
          const translatedSegment = t(translationKey);

          return (
            <Fragment key={path}>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{translatedSegment}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    {isRouteExist(path) ? (
                      <LinkProtected to={path}>{translatedSegment}</LinkProtected>
                    ) : (
                      <span className="pointer-events-none">{translatedSegment}</span>
                    )}
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default AppBreadcrumb;
